// extracted by css-extract-rspack-plugin
export default {"chipsContainer":"Participant_chipsContainer__yef6V","container":"Participant_container__g82Wh"};